import {Components} from "@mui/material/styles"
import {TypographyOptions} from "@mui/material/styles/createTypography"

export const SMALL_THEME_SIZE_TYPOGRAPHY: TypographyOptions = {
    h1: {
        fontSize: "5rem",
    },
    h2: {
        fontSize: "3rem",
    },
    h3: {
        fontSize: "2.5rem",
    },
    h4: {
        fontSize: "2rem",
    },
    h5: {
        fontSize: "1.2rem",
    },
    h6: {
        fontSize: "1rem",
    },
    subtitle1: {
        fontSize: "0.7rem",
    },
    subtitle2: {
        fontSize: "0.7rem",
    },
    body1: {
        fontSize: "0.8rem",
    },
    body2: {
        fontSize: "0.7rem",
    },
    button: {
        fontSize: "0.75rem",
    },
    caption: {
        fontSize: "0.55rem",
    },
    overline: {
        fontSize: "0.55rem",
    },
}


export const SMALL_THEME_SIZE_COMPONENTS: Components = {
    MuiCheckbox: {
        defaultProps: {
            size: 'small',
        },
        variants: [
            {
                props: {size: 'small'},
                style: {
                    margin: 0,
                    padding: 0,
                }

            }
        ]
    },
    MuiTableCell: {
        variants: [{
            props: {size: 'small'},
            style: {
                padding: '1px 3px'
            }
        }]
    },
    MuiButton: {
        variants: [
            {
                props: {size: 'small'},
                style: {
                    fontSize: '12px',
                    padding: '4px 15px',
                    textTransform: 'initial',
                }
            }
        ]
    },
    MuiChip: {
        defaultProps: {
            size: 'small'
        }
    },
    MuiIcon: {
        defaultProps: {
            fontSize: 'large'
        },
        styleOverrides:{
            root:{
                fontSize:'large'
            }
        }
    },
    MuiSwitch:{
        defaultProps: {
            size: 'small'
        },
    },
    MuiPagination:{
        defaultProps: {
            size: 'small'
        },
    }
}